module.exports = __webpack_public_path__ + "static/media/bubble.a8c2208f.svg";